import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link, NavLink, Outlet } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import MpgItem from "../../../CommonFormComp/MpgItem";
import { clientSpecificReportBasePath, thoughtLeadershipResourceBasePath } from "../../../routes/routePaths";
import { navLinkHeaderStylefunc, navfunc } from "../../../routes/navLinkStylefunc";
import { getAccessTypes } from "../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetSiteCoreCMSData } from "../../../reactQueries/commonRQHooks";

const ReportAndResourcesHeader = () => {
  const [adminClientSpecificCmsData, setAdminClientSpecificCmsData] = React.useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {}, });
  
  const {
    clientPortalAdminType
  } = getAccessTypes()

  const {
    hasA2Access,
    hasA3Access
  } = clientPortalAdminType

  const {isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: clinetSpecificCmsFromApi, isError: isErrorOnSiteCoreCMS, isFetching: isFetchingOnSiteCoreCMS} = useGetSiteCoreCMSData({pagename: "ReportsAndThoughtLeadership"});
  
  const fetchClientSpecificCmsData = () =>{
    if(clinetSpecificCmsFromApi && clinetSpecificCmsFromApi.Pages){
      clinetSpecificCmsFromApi.Pages.map((el) => {
       if (el.Key === "ReportsAndThoughtLeadership") {
         setAdminClientSpecificCmsData(el);
       }
   });
    }
  }

  React.useEffect(() => {
    fetchClientSpecificCmsData();
   }, [clinetSpecificCmsFromApi]);

  return (
    <React.Fragment>
      <Box sx={{ width: "100%" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          justifyContent="center"
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
        >

          <Button
            variant="text"
            size="large"
            component={NavLink}
            style={navLinkHeaderStylefunc}
            to={clientSpecificReportBasePath}
          >
              {adminClientSpecificCmsData?.Components && adminClientSpecificCmsData?.Components["ClientSpecificReportsList"]?.Title }     {/* Client specific reports */}
          </Button>
          <Button
            variant="text"
            size="large"
            component={NavLink}
            style={navLinkHeaderStylefunc}
            to={thoughtLeadershipResourceBasePath}
            disabled={
              //!!hasA2Access || hasA3Access // allowing for A2
              hasA3Access
            }
          >
            {adminClientSpecificCmsData?.Components && adminClientSpecificCmsData?.Components["ThoughtLeadershipList"]?.Title }
          </Button>
        </Stack>
        <Divider sx={{ margin: "10px" }} />
      </Box>
      {/** aquires all child route element components */}
      <Outlet context={{refClientSpecificCmsData:adminClientSpecificCmsData}}/>
    </React.Fragment>

  );
};

export default ReportAndResourcesHeader;
